module.exports = __webpack_public_path__ + "img/clement5-1600-min.fc4b479c.png";